<template>
  <div class="van-page">
    <the-header title="项目管家" isShowArrow />
    <van-sticky>
      <van-search class="search-box" v-model="keyword" placeholder="项目名称" shape="round" />
    </van-sticky>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getDataList">
      <div class="van-section" v-for="(item, index) in listData" :key="index">
        <div :class="{ 'van-section__header': true, 'active': item.MAIN_ASSIGN_USER !== '' }">
          <div class="van-section__title">{{ item.PROJECT_NAME }}</div>
          <span class="btn-edit" @click="handleEdit(item)">
            <van-icon name="ri ri-edit-2-fill" />
            编辑
          </span>
        </div>
        <div class="van-section__body">
          <ul class="list-group">
            <li>
              <span class="label">项目联系人</span>
              <span>{{ item.LINK_MAN }}</span>
            </li>
            <li>
              <span class="label">项目电话</span>
              <span>{{ item.LINK_PHONE || '暂无数据' }}</span>
            </li>
            <li v-if="item.MAIN_ASSIGN_USER">
              <span class="label">项目管家</span>
              <span>{{ item.MAIN_ASSIGN_USER }}</span>
            </li>
          </ul>
        </div>
      </div>
    </van-list>
    <!-- popup -->
    <van-popup v-model="popupShow" round closeable position="bottom" :style="{ height: '85%', paddingBottom: '2.3rem' }">
      <div class="van-popup-header">
        请选择项目管家
      </div>
      <van-radio-group v-model="radioValue">
        <van-cell-group>
          <van-cell v-for="(item, index) in radioList" :key="index" center :title="item.name" clickable
            @click="radioValue = item.code; radioName = item.name">
            <template #icon>
              <div class="avatar-icon">
                <i class="ri-user-2-fill"></i>
              </div>
            </template>
            <template #right-icon>
              <van-radio :name="item.code">
                <template #icon="props">
                  <i :class="props.checked ? 'ri-check-line' : ''" style="color: #377CF7;"></i>
                </template>
              </van-radio>
            </template>

          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <div class="popup-footer">
        <van-button type="info" block color="#427AF4" @click="submit">确认</van-button>
      </div>

    </van-popup>
  </div>
</template>

<script>
import _ from "lodash";
import { getBspPerson } from '@/api/interface/code'
import { getProjectByUserId } from '@/api/interface/project'
import { reallocationMajor } from '@/api/interface/manager'
export default {
  components: {
    'the-header': () => import('@/components/TheHeader')
  },
  data() {
    return {
      keyword: '',
      loading: false,
      finished: false,
      pageNo: 1,
      listData: [],
      popupShow: false,
      popupKeyword: '',
      radioValue: '',
      radioList: [],
      current: {}
    }
  },
  methods: {
    handleEdit(item) {
      this.current = item
      this.radioValue = item.MAIN_ASSIGN_ID || ''
      this.getUserList()
    },
    getDataList() {
      const user = this.$store.getters.getUser
      const instance = new getProjectByUserId({
        userId: user.postType == 'KY' ? user.userId : '',
        regionCode: user.postType == 'KZ' ? user.regionCode : '',
        page: this.pageNo++,
        rows: window.config.pageSize,
        projectName: this.keyword
      })
      instance
        .then((result) => {
          const data = JSON.parse(result.data.majorProjectData)
          if (data.length > 0) {
            this.listData = this.listData.concat(data.map(item => {
              if ('MAIN_ASSIGN_USER' in item) {
                return item
              } else {
                item.MAIN_ASSIGN_USER = ''
                return item
              }
            }))
            this.loading = false
            this.finished = false
          } else {
            this.$dialog.alert({
              message: '没有更多数据了'
            })
            this.loading = false
            this.finished = true
          }
        }).catch((err) => {
          console.log(err);
          this.$dialog.alert({
            message: '请求失败请联系开发人员'
          })
          this.loading = false
          this.finished = true
        });
    },
    getUserList() {
      const instance = new getBspPerson({
        orgCode: this.$store.getters.getUser.orgCode
      })
      instance
        .then((result) => {
          this.radioList = JSON.parse(result.data.data)
          this.popupShow = true
        }).catch((err) => {
          console.log(err);
        });
    },
    submit() {
      const instance = new reallocationMajor({
        seqId: this.current.SEQ_ID,
        userId: this.radioValue,
        userName: this.radioName,
      })
      instance
        .then((result) => {
          if (result.data.state == '200') {
            this.$dialog.alert({
              message: '分配成功'
            })
            Object.assign(this.listData.find(item => item.SEQ_ID === this.current.SEQ_ID), {
              MAIN_ASSIGN_USER: this.radioName,
              MAIN_ASSIGN_ID: this.radioValue
            })
            console.log(this.listData.find(item => item.SEQ_ID === this.current.SEQ_ID));
          }
          console.log();
          this.popupShow = false

        }).catch((err) => {
          console.log(err);
        });
    }
  },
  watch: {
    keyword: {
      handler: _.debounce(function (newVal) {
        this.pageNo = 1
        this.listData = []
        this.getDataList()
      }, 500),
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
.search-box {
  .van-search__content {
    border: 1px solid #EAEBEE;
    background: #fff;
  }
}

.van-container {
  padding: 12px 16px;
}

.van-section {
  background: #fff;
  margin-bottom: 12px;
  border-radius: 6px;
  position: relative;
}

.van-section__header {
  padding: 16px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    height: 1px;
    left: 12px;
    right: 12px;
    bottom: 0;
    background: #eee;
  }
}

.van-section__title {
  font-size: 16px;
  font-weight: 600;
  width: 85%;
}

.van-section__body {
  padding: 12px;
}

.btn-edit {
  color: #427AF4;
  font-size: 12px;
}

.list-group {
  font-size: 14px;

  >li {
    &+li {
      margin-top: 6px;
    }
  }

  .label {
    color: #868A93;
    width: 100px;
    display: inline-block;
  }
}

.van-popup-header {
  font-size: 16px;
  padding: 12px 16px;
  font-weight: 600;
}

.popup-search {
  .van-search__content {
    background: #F3F3F4;
  }
}

.search-box {
  .van-search__content {
    border: 1px solid #EAEBEE;
    background: #fff;
  }
}

.avatar-icon {
  height: 32px;
  width: 32px;
  background: rgba(55, 124, 247, 0.2);
  border-radius: 50%;
  color: #377CF7;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
}

.popup-footer {
  padding: 16px;
  background: #fff;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
}

.active {
  background-color: #427AF4;
  background: linear-gradient(to right,
      #7E3FF5,
      #6749F2,
      #515CF6,
      #3168F0,
      #427AF4,
      #85acff,
      #afc8ff,
      #d1d8ff,
      #e3e6ff,
    );
  color: #fff;
}</style>